import React from 'react';
import CodeBlock from '@/components/CodeBlock/CodeBlock';
import { ProTip } from '../../components/LessonUI';

const PythonPackaging = () => {
    return (
        <div className="tutorial-content-module">
            <div className="premium-header">
                <h1>Packaging & PyPI</h1>
                <p className="subtitle">From "Works on my machine" to "pip install my-tool". The professional distribution workflow.</p>
            </div>

            <div className="content-section">
                <h2>1. The Big Idea (ELI5)</h2>
                <ProTip><p>
                        Imagine you bake amazing Cookies (Code).
                    </p>
                    <ul>
                        <li><strong>Local Script:</strong> You hand a cookie to your friend. It breaks in their pocket. They ask "Does this contain nuts?" (Dependencies). You forgot to tell them.</li>
                        <li><strong>Packaging:</strong> You put the cookies in a <strong>Standardized Box</strong> (Package). You label it with Ingredients (Requirements), Expiration Date (Version), and Instructions (Docs). Now you can ship this box ANYWHERE in the world (PyPI), and the person receiving it knows exactly what they are getting.</li>
                    </ul></ProTip>
            </div>

            <div className="content-section">
                <h2>2. The Standard: `pyproject.toml`</h2>
                <p>
                    For 20 years, we used `setup.py`. That is DEAD.
                    The modern standard (PEP 621) is a static configuration file called `pyproject.toml`.
                </p>
                <CodeBlock language="toml" code={`[project]
name = "super_math_tool"
version = "1.0.0"
description = "A tool to calculate huge numbers"
authors = [
    {name = "Rohit User", email = "rohit@example.com"}
]
dependencies = [
    "numpy>=1.20",
    "requests<3.0"
]

[build-system]
requires = ["hatchling"]
build-backend = "hatchling.build"`} />
            </div>

            <div className="content-section">
                <h2>3. The Tooling Wars: Pip vs Poetry vs Hatch</h2>
                <p>
                    `pip` installs packages. It does NOT manage your project's build process.
                    Use a modern Package Manager:
                </p>
                <table className="premium-table">
                    <thead>
                        <tr>
                            <th>Tool</th>
                            <th>Role</th>
                            <th>Verdict</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><strong>Pip</strong></td>
                            <td>Installer</td>
                            <td>Good for simple scripts. Bad for libraries.</td>
                        </tr>
                        <tr>
                            <td><strong>Poetry</strong></td>
                            <td>Manager</td>
                            <td>The industry favorite. Handles locking & publishing.</td>
                        </tr>
                        <tr>
                            <td><strong>UV</strong></td>
                            <td>Installer</td>
                            <td>Built in Rust. 100x faster than pip. The future.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="content-section">
                <h2>4. Semantic Versioning (SemVer)</h2>
                <p>
                    Your version number `1.2.3` isn't random. It follows rules:
                </p>
                <ul className="premium-list">
                    <li><strong>MAJOR (1):</strong> Breaking changes. Old code might stop working.</li>
                    <li><strong>MINOR (2):</strong> New features, but backwards compatible.</li>
                    <li><strong>PATCH (3):</strong> Bug fixes only. Safe to update.</li>
                </ul>
            </div>

            <div className="content-section">
                <h2>5. Publishing to PyPI (The Repo)</h2>
                <p>
                    Once your package is built (into a `.whl` file), you upload it.
                </p>
                <CodeBlock language="bash" code={`# 1. Build the package
poetry build

# 2. Configure PyPI token
poetry config pypi-token.pypi pypi-AgEIpy...

# 3. Publish!
poetry publish`} />
                <ProTip><p><strong>Practice First:</strong> Always upload to <strong>TestPyPI</strong> first. It's a sandbox. You cannot delete files from real PyPI once uploaded (to prevent breaking the internet).</p></ProTip>
            </div>

        </div>
    );
};

export default PythonPackaging;

